import { SHOW, HIDE } from './actions';

const initialState = {
  show: false,
  type: null,
  options: null,
  returnFocusTo: null,
};

export type OverlayStateType = typeof initialState;

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW:
      const { returnFocusTo, type, options } = action.payload;
      return { ...state, show: true, type, options, returnFocusTo };
    case HIDE:
      return { ...initialState };
    default:
      return state;
  }
};
